import { Grow, InputLabelProps, SxProps, TextField } from '@mui/material'
import { FC } from 'react'

interface GroboticTextFieldProps {
  label: string
  value: string | number
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  size: 'small' | 'medium'
  sx: SxProps
  placeholder: string
  inputprops: InputLabelProps
  showExtras: boolean
  fadetime: number
}

const GroboticTextField: FC<GroboticTextFieldProps> = ({
  label,
  value,
  onChange,
  size,
  sx,
  placeholder,
  inputprops,
  showExtras,
  fadetime,
}) => (
  <Grow in={showExtras} style={{ transformOrigin: '0 0 0' }} {...(showExtras ? { timeout: fadetime ?? 1000 } : {})}>
    <TextField
      label={label ?? 'text label'}
      value={value ?? ''}
      onChange={onChange}
      size={size ?? 'small'}
      sx={sx ?? {}}
      placeholder={placeholder}
      InputLabelProps={inputprops ?? {}}
    />
  </Grow>
)
export default GroboticTextField
